var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-Designs","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round"},React.createElement("g",{"id":"Unum-Home-Page","transform":"translate(-1311.000000, -33.000000)","stroke":"#015294","strokeWidth":"2"},React.createElement("g",{"id":"Banner"},React.createElement("g",{"id":"Group","transform":"translate(1250.000000, 26.000000)"},React.createElement("path",{"d":"M66,11.9895924 L62,7.98959236 L66,11.9895924 L70,7.98959236 L66,11.9895924 Z M66,11.9895924 L70,15.9895924 L66,11.9895924 L62,15.9895924 L66,11.9895924 Z","id":"Line-5"}))))));
}

CrossInline.defaultProps = {"width":"10px","height":"10px","viewBox":"0 0 10 10","version":"1.1"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
